import React from 'react'
import * as Yup from 'yup'

import { TtButton, TtCard } from '@23/ui-react'
import * as TtForms from '@23/react-forms'

import type { WidgetDTO } from '../../../../../../model/Widget'

const calendlySchema = Yup.object({
  link: Yup.string()
    .trim()
    .transform((v) => (v === '' ? undefined : v))
    .required('Calendly URL is required')
    .url('Invalid URL format')
    .matches(
      /^https:\/\/calendly\.com\//,
      'Link should start with "https://calendly.com/"'
    ),
})

type FormValues = Yup.InferType<typeof calendlySchema>

interface CalendlyEditModeProps {
  widget: WidgetDTO
  onSave: (values: FormValues) => Promise<void>
  onCancel: () => void
}

const CalendlyEditMode = ({
  widget,
  onSave,
  onCancel,
}: CalendlyEditModeProps) => (
  <TtCard
    className="personal-widget-calendly personal-widget-calendly--edit"
    hideLabel
  >
    <TtForms.Form<FormValues>
      className="personal-widget-calendly-form"
      label="Edit Calendly URL"
      initialValues={{
        link: widget.link ?? '',
      }}
      validationSchema={calendlySchema}
      onSubmit={onSave}
      enableReinitialize
    >
      <TtForms.TextField<FormValues>
        name="link"
        label="Calendly calendar link"
        placeholder="https://calendly.com/your-username"
      />
      <div className="personal-widget-calendly-form-actions">
        <TtButton variant="outline" color="secondary" onClick={onCancel}>
          Cancel
        </TtButton>
        <TtForms.SubmitButton color="primary" disabled={false}>
          Save
        </TtForms.SubmitButton>
      </div>
    </TtForms.Form>
  </TtCard>
)

export { type FormValues as CalendlyFormValues, CalendlyEditMode }
